import React from "react";
export const TableHeaders = [
  {
    heights: { header1: "70px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "CHECK LIST",
        colSpan: 6,
        rowSpan: 1,
        // topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "ITEMS",
        colSpan: 5,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "year",
        isTitleOnly: true,
      },
      {
        title: "Inspected",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "year",
        isTitleOnly: true,
      },
    ],
  },
];

export const getTemplate = (title, id) => {
  return {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: title,
        colSpan: 5,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: id,
        unBold: true,
        isTitleOnly: true,
      },
      {
        title: title,
        colSpan: 1,
        centerAlign: true,
        className: "tbl-text-normal",
        accessor: id,
        unBold: true,
        isValueOnly: true,
        formatter: (vals) => {
          return <span style={{ fontSize: "14px" }}>{typeof vals === "boolean" ? (vals ? "YES" : "") : ""}</span>;
        },
      },
    ],
  };
};

export const getSchemaList = (OEM) => {
  const { opt2 } = OEM;
  const { table } = opt2;
  let data = [];
  for (let index = 0; index < table.length; index++) {
    let item = table[index];
    const id = `${item.checkItemName.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()}${index}`;
    const name = item.checkItemName;

    data.push({
      id: id,
      name: name,
    });
  }
  return data;
};
export const EngineHoursSchema = {
  heights: { header1: "40px" },
  classes: { header2: "" },
  inlineData: true,
  columns: [
    {
      title: "Engine Hours",
      colSpan: 5,
      rowSpan: 1,
      topAlign: true,
      className: "tbl-text-normal",
      accessor: "",
      isTitleOnly: true,
    },
    {
      title: "eng",
      colSpan: 3,
      rowSpan: 1,
      topAlign: true,
      className: "tbl-text-normal",
      accessor: "engHour",
      isValueOnly: true,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/OEMSingleReport/Schema.jsx